import { store } from '@betacrew/jars-flux';
export const componentKey = "ENTRATA_SWITCH";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setTenantList: (state, action) => {
            state.tenantList = action.payload;
        },
        setFormAndTaxYearList: (state, action) => {
            state.formAndTaxYearList = action.payload;
        },
        setImportData: (state, action) => {
            state.importData = action.payload;
        },
        setIsImportDataGridViewLoaded: (state, action) => {
            state.isImportDataGridViewLoaded = action.payload;
        },
        setFormSettings: (state, action) => {
            state.formSettings = action.payload;
        },
    },
    initialReducerState: {
        loadingState: false,
        tenantList: [],
        formAndTaxYearList: {},
        importData: null,
        isImportDataGridViewLoaded: false,
        formSettings: null,
    }
});
export const { setLoadingState, setTenantList, setFormAndTaxYearList, setImportData, setIsImportDataGridViewLoaded, setFormSettings} = actions;